export const formatPhoneNumber = (phone) => {
  if (!phone) return "";

  let cleaned = phone.replace(/\D/g, "");

  if (cleaned.startsWith("0")) {
    cleaned = "234" + cleaned.slice(1);
  }

  if (cleaned.startsWith("234")) {
    return cleaned;
  }

  return cleaned;
};
